import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import { IRootState } from '../../../typings';
import filterList from '../../actions/lists';
import { parseQuery } from '../../services/parseQuery';
import { addUser, fetchUsers } from '../actions';

type IOwnProps = RouteComponentProps;

const mapDispatchToProps = {
  filterList,
  fetchUsers,
  addUser,
};

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  return {
    me: state.me,
    users: state.users.list,
    pagination: state.users.pagination,
    fetching: state.users.fetching,
    total: state.users.totalItems,
    query: parseQuery(ownProps.location.search),
  };
};

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  IOwnProps;

const reduxConnector = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const connector = compose<IComponentProps, IOwnProps>(
  reduxConnector,
  injectIntl
);
